import Base from './Base';

export default class PendingMention extends Base {}
